import React from 'react';

const SidebarSection = ({ title, collapsed }) => {
  if (!title || collapsed) return null;

  return (
    <div
      style={{
        marginTop: '14px',
        marginBottom: '4px',
        padding: '0 14px',
        fontSize: '10px',
        fontWeight: '700',
        color: '#94a3b8',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        userSelect: 'none'
      }}
    >
      {title}
    </div>
  );
};

export default SidebarSection;
